export default __webpack_public_path__ + "static/media/Robocone.2bb40ae8.jpeg";